import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import rootSlice from './root-slice';

const reducer = combineReducers({
    root: rootSlice.reducer,
});

const storeDesktop = configureStore({
    reducer,
})

export const rootActionsDesktop = rootSlice.actions;
export default storeDesktop;

/**
 * Infer the `RootState` and `AppDispatch` types from the store itself
 * https://redux.js.org/recipes/usage-with-typescript
 */
export type RootStateDesktop = ReturnType<typeof storeDesktop.getState>;
export type AppDispatchDesktop = typeof storeDesktop.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
// https://redux.js.org/recipes/usage-with-typescript
export const useAppDispatchDesktop = () => useDispatch<AppDispatchDesktop>();
export const useAppSelectorDesktop: TypedUseSelectorHook<RootStateDesktop> = useSelector;
